
export const documentBundlePaths = {
  '/document-bundles/list': {
    post: {
      summary: 'List document bundles',
      operationId: 'listDocumentBundles',
      tags: ['Document Bundles'],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              type: 'object',
              properties: {
                search: { type: 'string', description: 'Optional search term for bundle name' },
                limit: { type: 'integer', description: 'Maximum number of results to return' },
                offset: { type: 'integer', description: 'Number of results to skip' }
              }
            }
          }
        }
      },
      responses: {
        '200': {
          description: 'List of document bundles',
          content: {
            'application/json': {
              schema: {
                type: 'array',
                items: {
                  type: 'object',
                  properties: {
                    id: { type: 'integer' },
                    name: { type: 'string' },
                    description: { type: 'string' },
                    normal_fee: { type: 'number' },
                    rush_fee: { type: 'number' },
                    variable_by_applicants: { type: 'boolean' },
                    savings: { type: 'number' },
                    documents: {
                      type: 'array',
                      items: { type: 'object' }
                    },
                    created_at: { type: 'string', format: 'date-time' },
                    updated_at: { type: 'string', format: 'date-time' }
                  }
                }
              }
            }
          }
        },
        '400': {
          description: 'Error response',
          content: {
            'application/json': {
              schema: { $ref: '#/components/schemas/ErrorResponse' }
            }
          }
        }
      }
    }
  }
};
